export default {
    userMembership:{}
}